import(/* webpackMode: "eager" */ "/home/runner/work/MONADATY/MONADATY/app/error.tsx");
